import { useState, useEffect, useRef, } from "react";
import { useContext, useMemo } from "react";
import LevelTransmitterIndicator from "../components/LevelTransmitterIndicator";
import Transmitter from "../components/Transmitter";
import ControlValveControlPanel from "../components/ControlValveControlPanel";
import Valve from "../components/Valve";
import "./ProductStripper.css";
import { WellContext } from "../context/WellContext";
import { AlarmContext } from "../context/AlarmContext";
import { PumpContext } from "../context/PumpContext"; 
import { ProcessContext } from "../context/ProcessContext";
import Pump from "../components/Pump";
import PumpFaceplate from "../components/PumpFaceplate";
import { PlantStore } from "../engine/PlantStore";
import { usePlantStore } from "../engine/usePlantStore";
import StripperLaboratory from "./StripperLaboratory";


import { trackPageVisit } from "../competency/PageTracker";
import TransmitterFaceplate from "../components/TransmitterFaceplate";





function ValveOutput({
    tag,
    value,
    x,
    y,
    r = 0,
    description = "Control Valve Opening"
}) {

    const [hover, setHover] = useState(false);
    const [showFaceplate, setShowFaceplate] = useState(false);

    return (
        <>
            {/* Hover */}
            {hover && (
                <div
                    style={{
                        position: "absolute",
                        left: x + 30,
                        top: y - 5,
                        background: "rgba(0,80,180,.85)",
                        color: "#fff",
                        padding: "5px 8px",
                        borderRadius: "4px",
                        border: "1px solid #4fc3ff",
                        fontSize: "11px",
                        zIndex: 9999,
                        pointerEvents: "none",
                        whiteSpace: "nowrap"
                    }}
                >
                    <strong>{tag}</strong><br />
                    {description}
                </div>
            )}

            {/* Original Valve Output */}
            <div
                onMouseEnter={() => setHover(true)}
                onMouseLeave={() => setHover(false)}
                onClick={() => setShowFaceplate(true)}
                style={{
                    position: "absolute",
                    left: x,
                    top: y,

                    color: "lime",
                    background: "black",

                    fontSize: "10px",
                    padding: "1px 4px",

                    borderRadius: "4px",
                    border: "1px solid #555",

                    transform: `rotate(${r}deg)`,
                    transformOrigin: "center",

                    cursor: "pointer",

                    fontWeight: "bold",

                    minWidth: "22px",
                    textAlign: "center",

                    transition: "0.2s",
                    boxShadow: hover
                        ? "0 0 8px rgba(0,255,255,.7)"
                        : "none"
                }}
            >
                {Number(value).toFixed(1)} %
            </div>

            {showFaceplate && (
                <TransmitterFaceplate
                    tag={tag}
                    value={Number(value)}
                    unit="%"
                    min={0}
                    max={100}
                    HH={100}
                    H={90}
                    L={10}
                    LL={0}
                    description={description}
                    x={x + 35}
                    y={y + 20}
                    onClose={() => setShowFaceplate(false)}
                />
            )}
        </>
    );
}




function ProductStripper() {

    useEffect(() => {
    
      trackPageVisit("ProductStripper");
    
    }, []);
  
     const {  valves, toggleValve} = useContext(WellContext);

const [hoveredValve, setHoveredValve] = useState(null);
  const {processData,  setProcessData} = useContext(ProcessContext);
  const [showLaboratory, setShowLaboratory] = useState(false);

     

  const DEFAULT_VALVES = {
  FCV_2401: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_2402: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_2403: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_2404: { mode: "Manual", opening: 0, sp: "", pv: "" },

};

const [valveData, setValveData] = useState(() => {
  const saved = localStorage.getItem("ProductStripper_valveData");

  if (!saved) return DEFAULT_VALVES;

  try {
    const parsed = JSON.parse(saved);

    // ✅ Merge saved + default (CRITICAL)
    return {
      FCV_2401: { ...DEFAULT_VALVES.FCV_2401, ...parsed.FCV_2401 },
      FCV_2402: { ...DEFAULT_VALVES.FCV_2402, ...parsed.FCV_2402 },
      FCV_2403: { ...DEFAULT_VALVES.FCV_2403, ...parsed.FCV_2403 },
      FCV_2404: { ...DEFAULT_VALVES.FCV_2404, ...parsed.FCV_2404 },

    };

  } catch {
    return DEFAULT_VALVES;
  }
});



/* ✅ Persist */
  useEffect(() => {
    localStorage.setItem("ProductStripper_valveData", JSON.stringify(valveData));
  }, [valveData]);

  /* ================= ✅ FIXED UPDATE FUNCTION ================= */
  const updateValveData = (tag, field, value) => {
  setValveData(prev => ({
    ...prev,
    [tag]: {
      ...(prev[tag] || DEFAULT_VALVES[tag]),
      [field]: field === "opening" ? Number(value) || 0 : value
    }
  }));
};

  /* ================= PANEL CONTROL ================= */
  const [openPanels, setOpenPanels] = useState([]);

  const openPanel = (tag) => {
    if (!openPanels.includes(tag)) {
      setOpenPanels(prev => [...prev, tag]);
    }
  };

  const closePanel = (tag) => {
    setOpenPanels(prev => prev.filter(p => p !== tag));
  };


  // ================= PUMP PANEL LOGIC =================

  const [openPumpPanels, setOpenPumpPanels] = useState([]);

const openPumpPanel = (tag) => {
  if (!openPumpPanels.includes(tag)) {
    setOpenPumpPanels(prev => [...prev, tag]);
  }
};

const closePumpPanel = (tag) => {
  setOpenPumpPanels(prev => prev.filter(p => p !== tag));
};





const [panelPos, setPanelPos] = useState({ x: 0, y: 80 });
const [dragging, setDragging] = useState(false);
const offsetRef = useRef({ x: 0, y: 0 });

const handleMouseDown = (e) => {
  setDragging(true);

  offsetRef.current = {
    x: e.clientX - panelPos.x,
    y: e.clientY - panelPos.y,
  };
};

const handleMouseMove = (e) => {
  if (!dragging) return;

  setPanelPos({
    x: e.clientX - offsetRef.current.x,
    y: e.clientY - offsetRef.current.y,
  });
};

const handleMouseUp = () => {
  setDragging(false);
};

useEffect(() => {
  window.addEventListener("mousemove", handleMouseMove);
  window.addEventListener("mouseup", handleMouseUp);

  return () => {
    window.removeEventListener("mousemove", handleMouseMove);
    window.removeEventListener("mouseup", handleMouseUp);
  };
}, [dragging]);




const tagStyle = {
      position: "absolute",
      top: -30,
      left: "50%",
      transform: "translateX(-50%)",

      background: "black",
      color: "#00ffcc",

      fontSize: "13px",
      fontWeight: "bold",

      padding: "3px 8px",
      borderRadius: "4px",

      border: "1px solid #555",

      whiteSpace: "nowrap",
      zIndex: 999
    };


// ================= RETREIVING OF DATA FROM OTHER PAGES VIA LOCAL STROAGE =================
    
                const { transmitters, flowOverrides } = usePlantStore();
                const TT_21011 = transmitters.TT_21011 || 0;
                const PT_21011 = transmitters.PT_21011 || 0;
  

  const FIC_2305 =
  Number(
    localStorage.getItem(
      "FIC_2305"
    )
  ) || 0;

  const TT_2305 =
  Number(
    localStorage.getItem(
      "TT_2305"
    )
  ) || 0;

  const PT_2305 =
  Number(
    localStorage.getItem(
      "PT_2305"
    )
  ) || 0;

  const FIC_2203 =
  Number(
    localStorage.getItem(
      "FIC_2203"
    )
  ) || 0;

  const TT_2203 =
  Number(
    localStorage.getItem(
      "TT_2203"
    )
  ) || 0;

  const PT_2203 =
  Number(
    localStorage.getItem(
      "PT_2203"
    )
  ) || 0;

  const TT_2206 =
  Number(
    localStorage.getItem(
      "TT_2206"
    )
  ) || 0;


const DieselProductComposition =
  JSON.parse(
    localStorage.getItem(
      "DieselProductComposition"
    ) || "{}"
  );





  const xv2401Open = !valves?.XV_2401;
  const xv2402Open = !valves?.XV_2402;
  const xv2403Open = !valves?.XV_2403;


  const FIC_2401 = FIC_2305;
  const TT_2401 = TT_2305;
  const PT_2401 = PT_2305;

  const FIC_2402 = FIC_2203;
  const TT_2402 = TT_2203;
  const PT_2402 = PT_2203;

  const TT_2403 = TT_21011;
  const PT_2403 = PT_21011;
  const FIC_2403 = 13.54 * (valveData?.FCV_2403?.opening || 0)/50;



  const TT_24020 = TT_2206;

  const DieselInlet =

  DieselProductComposition.Diesel || 0;

const VGOInlet =

  DieselProductComposition.VGO || 0;


  console.log("DieselProductComposition", DieselProductComposition);

console.log("DieselInlet", DieselInlet);

console.log("VGOInlet", VGOInlet);

console.log("FIC_2401", FIC_2401);


  /* =========================================================
   DIESEL STRIPPER MODEL
========================================================= */

/*
TT_2401
=
Diesel feed temperature

PT_2401
=
Stripper operating pressure

FIC_2401
=
Diesel feed

TT_2403
=
Superheated steam

FIC_2403
=
Steam flow
*/

/* =========================================================
   TEMPERATURE EFFECT
========================================================= */

let TemperatureFactor = 0;

if (TT_2401 < 180)
{
  TemperatureFactor = 0.20;
}
else if (TT_2401 < 210)
{
  TemperatureFactor = 0.45;
}
else if (TT_2401 < 240)
{
  TemperatureFactor = 0.70;
}
else if (TT_2401 < 270)
{
  TemperatureFactor = 0.90;
}
else
{
  TemperatureFactor = 1.00;
}

/* =========================================================
   PRESSURE EFFECT
========================================================= */

const PressureFactor =

  Math.max(
    0.60,

    1 -

    (
      PT_2401 * 0.05
    )
  );

/* =========================================================
   STEAM STRIPPING EFFECT
========================================================= */

const SteamRatio =

  FIC_2401 > 0

    ?

    FIC_2403 /
    FIC_2401

    :

    0;

const SteamStrippingFactor =

  Math.min(

    1,

    SteamRatio * 2.5

  );

/* =========================================================
   STRIPPING SEVERITY
========================================================= */

const StrippingSeverity =

  TemperatureFactor *

  PressureFactor *

  (
    0.55 +
    SteamStrippingFactor
  );




  /* =========================================================
   DIESEL GAS RETURN
========================================================= */

/*
Only a small portion
of diesel becomes
stripper overhead.
*/

const DieselLightEndsFraction =

  Math.min(

    0.15,

    StrippingSeverity * 0.12

  );

/*
Only diesel contributes
to stripper overhead.

VGO is too heavy.
*/

const DieselGasReturn =

  DieselInlet *

  DieselLightEndsFraction;

const FIC_2405 =
  DieselGasReturn;





  /* =========================================================
   DIESEL PRODUCT
========================================================= */

const DieselBottoms =

  DieselInlet -

  DieselGasReturn;

const VGOBottoms =

  VGOInlet;

const DieselBottomComposition = {

  Diesel:
    DieselBottoms,

  VGO:
    VGOBottoms

};

const FIC_2404 =

  DieselBottoms +

  VGOBottoms;




  /* =========================================================
   PRODUCT TEMPERATURE
========================================================= */

const SteamHeating =

  SteamRatio * 18;

const TT_2404 =

  TT_2401 +

  SteamHeating -

  (
    DieselLightEndsFraction * 15
  );





  /* =========================================================
   GAS RETURN TEMPERATURE
========================================================= */

const TT_2405 =

  TT_2404 +

  10 +

  (
    SteamRatio * 12
  );


  /* =========================================================
   STRIPPER PRESSURES
========================================================= */

const PT_2404 =

  Math.max(

    0.05,

    PT_2401 -

    0.01

  );

const PT_2405 =

  Math.max(

    0.05,

    PT_2404 -

    0.01

  );




  /* =========================================================
   PUMP CONTEXT
========================================================= */

const pumpContext = useContext(PumpContext) || {};
const pumpData = pumpContext.pumpData || {};


/* =========================================================
   P-106A / P-106B DIESEL PUMPS
========================================================= */

const P106A_Running =
  pumpData?.["P-106A"]?.running ?? false;

const P106B_Running =
  pumpData?.["P-106B"]?.running ?? false;

const P106_Running =
  P106A_Running || P106B_Running;

/* =========================================================
   PUMP CAPACITY
========================================================= */

const P106_CAPACITY = 15.43;

/* =========================================================
   CONTROL VALVES
========================================================= */

const FCV2401_Opening =
  (valveData?.FCV_2401?.opening || 0) / 100;

const FCV2402_Opening =
  (valveData?.FCV_2402?.opening || 0) / 100;

/* =========================================================
   TOTAL VALVE OPENING
========================================================= */

const TotalOpening =
  FCV2401_Opening +
  FCV2402_Opening;

/* =========================================================
   AVAILABLE PUMP FLOW
========================================================= */

const PumpAvailableFlow =
  P106_Running
    ? P106_CAPACITY
    : 0;

/* =========================================================
   EFFECTIVE PUMP FLOW

   Total flow depends on the combined valve opening,
   but can never exceed the pump capacity.
========================================================= */

const EffectivePumpFlow =
  PumpAvailableFlow *
  Math.min(TotalOpening, 1);

/* =========================================================
   TARGET FLOWS
========================================================= */

let targetFIC_2406 = 0;
let targetFIC_2407 = 0;

if (EffectivePumpFlow > 0 && TotalOpening > 0) {

  targetFIC_2406 =
    EffectivePumpFlow *
    (FCV2401_Opening / TotalOpening);

  targetFIC_2407 =
    EffectivePumpFlow *
    (FCV2402_Opening / TotalOpening);

}

/* =========================================================
   FIC-2406
========================================================= */


const FIC_2406 = flowOverrides?.FIC_2406 ? 0 : (processData.FIC_2406 || 0);

useEffect(() => {

  const lastUpdate =
    Number(
      localStorage.getItem(
        "FIC_2406_LastUpdate"
      )
    ) || Date.now();

  const elapsedSeconds =
    (Date.now() - lastUpdate) / 1000;

  if (elapsedSeconds <= 1) return;

  setProcessData(prev => {

    const current =
      Number(prev.FIC_2406 || 0);

    let next = current;

    const systemActive =
      P106A_Running ||
      P106B_Running;

    const target =
      systemActive
        ? targetFIC_2406
        : 0;

    /* ====================================
       MAXIMUM 100 SCANS
       ==================================== */

    const scans =
      Math.min(
        Math.floor(
          elapsedSeconds * 10
        ),
        100
      );

    for (
      let i = 0;
      i < scans;
      i++
    ) {

      next =
        next +
        (
          target -
          next
        ) * 0.12;

    }

    return {
      ...prev,
      FIC_2406: Number(
        next.toFixed(3)
      )
    };

  });

}, [
  targetFIC_2406,
  P106A_Running,
  P106B_Running
]);



useEffect(() => {

  localStorage.setItem(
    "FIC_2406_LastUpdate",
    String(Date.now())
  );

}, [FIC_2406]);




useEffect(() => {

  const timer = setInterval(() => {

    setProcessData(prev => {

      const current =
        Number(prev.FIC_2406 || 0);

      const target =
        Number(targetFIC_2406 || 0);

      const next =
        current +
        (target - current) * 0.12;

      return {
        ...prev,
        FIC_2406: Number(next.toFixed(3))
      };

    });

  }, 500);

  return () => clearInterval(timer);

}, [targetFIC_2406]);


/* =========================================================
   FIC-2407
========================================================= */
  const FIC_2407 = flowOverrides?.FIC_2407 ? 0 : (processData.FIC_2407 || 0);

useEffect(() => {

  const lastUpdate =
    Number(
      localStorage.getItem(
        "FIC_2407_LastUpdate"
      )
    ) || Date.now();

  const elapsedSeconds =
    (Date.now() - lastUpdate) / 1000;

  if (elapsedSeconds <= 1) return;

  setProcessData(prev => {

    const current =
      Number(prev.FIC_2407 || 0);

    let next = current;

    const systemActive =
      P106A_Running ||
      P106B_Running;

    const target =
      systemActive
        ? targetFIC_2407
        : 0;

    /* ====================================
       MAXIMUM 100 SCANS
       ==================================== */

    const scans =
      Math.min(
        Math.floor(
          elapsedSeconds * 10
        ),
        100
      );

    for (
      let i = 0;
      i < scans;
      i++
    ) {

      next =
        next +
        (
          target -
          next
        ) * 0.12;

    }

    return {
      ...prev,
      FIC_2407: Number(
        next.toFixed(3)
      )
    };

  });

}, [
  targetFIC_2407,
  P106A_Running,
  P106B_Running
]);



useEffect(() => {

  localStorage.setItem(
    "FIC_2407_LastUpdate",
    String(Date.now())
  );

}, [FIC_2407]);




useEffect(() => {

  const timer = setInterval(() => {

    setProcessData(prev => {

      const current =
        Number(prev.FIC_2407 || 0);

      const target =
        Number(targetFIC_2407 || 0);

      const next =
        current +
        (target - current) * 0.12;

      return {
        ...prev,
        FIC_2407: Number(next.toFixed(3))
      };

    });

  }, 500);

  return () => clearInterval(timer);

}, [targetFIC_2407]);

/* =========================================================
   TOTAL FLOW
========================================================= */

const FIC_2408 =
  Number(
    (
      FIC_2406 +
      FIC_2407
    ).toFixed(3)
  );

/* =========================================================
   PT-2406
========================================================= */

let PT_2406 = 0.03;

if (
  P106_Running &&
  TotalOpening > 0
) {

  PT_2406 = 1.5;

}

PT_2406 =
  Number(PT_2406.toFixed(3));

/* =========================================================
   TT-2406
========================================================= */

const AtmosphericTemperature = 32.54;

let TT_2406 =
  AtmosphericTemperature;

if (
  P106_Running &&
  TotalOpening > 0
) {

  TT_2406 = TT_2404;

}

TT_2406 =
  Number(TT_2406.toFixed(2));






  /* =========================================================
   KEROSENE PRODUCT COMPOSITION
========================================================= */

const KeroseneProductComposition =

  JSON.parse(

    localStorage.getItem(
      "KeroseneProductComposition"
    ) || "{}"

  );

console.log(
  "Loaded KeroseneProductComposition",
  KeroseneProductComposition
);


const KeroseneInlet =

  KeroseneProductComposition.Kerosene || 0;

const DieselInKerosene =

  KeroseneProductComposition.Diesel || 0;


/* =========================================================
   KEROSENE STRIPPER MODEL
========================================================= */

/*
Feed:
FIC_2402

Heat Source:
Diesel Reboiler

Products:
Bottom Kerosene
Overhead Gas Return
*/


/* =========================================================
   KEROSENE REBOILER CIRCULATION
========================================================= */

const ReboilerCirculationFraction =

  xv2401Open ? 0.28 : 0;

const FIC_24011 = flowOverrides?.FIC_24013 ? 0 :

  (FIC_2402 *

  ReboilerCirculationFraction);

const TT_24011 = xv2401Open ?

  TT_2402 : AtmosphericTemperature;

const PT_24011 =

  PT_2402;




/* =========================================================
   KETTLE REBOILER HEAT EXCHANGE
========================================================= */

/*
Hot Side:
Diesel
TT_2406
FIC_2406

Cold Side:
Kerosene
TT_24011
FIC_24011
*/

/*
No heat exchange unless BOTH
streams are flowing.
*/

const HeatExchangeAvailable =

  FIC_2406 > 0.01 &&

  FIC_24011 > 0.01;


/* =========================================================
   FLOW RATIO
========================================================= */

/*
The smaller flowing stream
limits the exchanger duty.
*/

const FlowRatio =

  HeatExchangeAvailable

    ?

    Math.min(
      FIC_2406,
      FIC_24011
    ) /

    Math.max(
      FIC_2406,
      FIC_24011
    )

    :

    0;


/* =========================================================
   EFFECTIVENESS
========================================================= */

/*
Overall exchanger effectiveness.
*/

const HeatTransferEfficiency =

  HeatExchangeAvailable

    ?

    0.45 +

    (
      FlowRatio * 0.45
    )

    :

    0;


/* =========================================================
   MAXIMUM TEMPERATURE DIFFERENCE
========================================================= */

const DeltaT =

  TT_2406 -

  TT_24011;


/* =========================================================
   ACTUAL HEAT TRANSFER
========================================================= */

const HeatTransferred =

  HeatExchangeAvailable

    ?

    DeltaT *

    HeatTransferEfficiency

    :

    0;


/* =========================================================
   REBOILER OUTLET
========================================================= */

const FIC_24012 =

  FIC_24011;

/* =========================================================
   KEROSENE OUT OF REBOILER
========================================================= */

const TT_24012 =

  HeatExchangeAvailable

    ?

    TT_24011 +

    HeatTransferred

    :

    TT_24011;


/* =========================================================
   DIESEL OUT OF REBOILER
========================================================= */

/*
Diesel gives up heat.

The cooling depends strongly
on diesel flow.
*/

const DieselCooling =

  HeatExchangeAvailable

    ?

    HeatTransferred *

    (
      FIC_24011 /

      Math.max(
        FIC_2406,
        0.01
      )
    )

    :

    0;

const TT_24081 =

  HeatExchangeAvailable

    ?

    TT_2406 -

    DieselCooling

    :

    TT_2406;


    const PT_24012 =

  Math.max(
    0.05,
    PT_24011 - 0.02
  );

const PT_24081 =

  Math.max(
    0.05,
    PT_2404 - 0.02
  );




/* =========================================================
   REBOILER DUTY
========================================================= */

const ReboilerDuty =

  HeatTransferred *

  FIC_24011;


/* =========================================================
   REBOILER DUTY FACTOR
========================================================= */

const DutyFactor =

  Math.min(

    1,

    ReboilerDuty /

    120

  );



/* =========================================================
   LIGHT ENDS FRACTION
========================================================= */

/*
Small percentage
removed overhead.

Depends on:

Temperature

Pressure

Reboiler Duty
*/

const LightEndsFraction =

  Math.min(

    0.12,

    0.02 +

    (

      StrippingSeverity *

      0.10

    )

  );


/* =========================================================
   DIESEL CARRY OVER
========================================================= */

/*
Only traces of diesel
leave overhead.
*/

const DieselCarryFraction =

  Math.min(

    0.05,

    LightEndsFraction *

    0.35

  );



  /* =========================================================
   KEROSENE GAS RETURN
========================================================= */

/*
A small amount of kerosene is stripped
from the feed together with traces of diesel.
This stream returns to the atmospheric tower.
*/

const KeroseneGasReturn =

  KeroseneInlet *

  LightEndsFraction;

const DieselGasCarryOver =

  DieselInKerosene *

  DieselCarryFraction;

const KeroseneGasComposition = {

  Kerosene:
    KeroseneGasReturn,

  Diesel:
    DieselGasCarryOver

};

const FIC_24010 =

  KeroseneGasReturn +

  DieselGasCarryOver;


/* =========================================================
   KEROSENE BOTTOM PRODUCT
========================================================= */

const BottomKerosene =

  Math.max(

    0,

    KeroseneInlet -

    KeroseneGasReturn

  );

const BottomDiesel =

  Math.max(

    0,

    DieselInKerosene -

    DieselGasCarryOver

  );

const KeroseneBottomComposition = {

  Kerosene:
    BottomKerosene,

  Diesel:
    BottomDiesel

};

const FIC_2409 =

  BottomKerosene +

  BottomDiesel;


/* =========================================================
   PRODUCT TEMPERATURE
========================================================= */

/*
Bottom product is slightly cooler after
the light ends have been stripped.
*/

const TT_2409 =

  TT_24012 -

  (

    LightEndsFraction *

    18

  );


/* =========================================================
   GAS RETURN TEMPERATURE
========================================================= */

/*
The stripped vapour leaving the top of
the stripper is slightly hotter.
*/

const TT_24010 =

  TT_24012 +

  8 +

  (

    StrippingSeverity *

    10

  );


/* =========================================================
   PRODUCT PRESSURES
========================================================= */

const PT_2409 =

  Math.max(

    0.05,

    PT_2402 -

    0.01

  );

const PT_24010 =

  Math.max(

    0.05,

    PT_2409 -

    0.01

  );


/* =========================================================
   MATERIAL BALANCE
========================================================= */

const TotalOut =

  FIC_2409 +

  FIC_24010;

const BalanceError =

  FIC_2402 -

  TotalOut;


/*
Force exact mass balance.
*/

if (

  Math.abs(BalanceError) >

  0.000001

)

{

  const CorrectedBottom =

    FIC_2409 +

    BalanceError;

  if (CorrectedBottom >= 0)
  {

    const Ratio =

      FIC_2409 > 0

        ?

        CorrectedBottom /

        FIC_2409

        :

        1;

    KeroseneBottomComposition.Kerosene *= Ratio;

    KeroseneBottomComposition.Diesel *= Ratio;

  }

}




/* =========================================================
   DIESEL MIXING AFTER REBOILER
========================================================= */

/*
TT_2406
=
Diesel before reboiler

TT_24081
=
Diesel leaving reboiler

TT_2408
=
Mixed diesel stream
*/

/*
Fraction of diesel passing
through the reboiler.
*/

const ReboilerFraction =

  FIC_2406 > 0.01

    ?

    Math.min(
      1,
      FIC_24011 /
      FIC_2406
    )

    :

    0;


/*
Final mixed diesel temperature.
*/

const TT_2408 =

  HeatExchangeAvailable

    ?

    (
      TT_24081 *
      ReboilerFraction
    ) +

    (
      TT_2406 *
      (1 - ReboilerFraction)
    )

    :

    TT_2406;


/* =========================================================
   SAVE TO LOCAL STORAGE
========================================================= */

localStorage.setItem(

  "FIC_2409",

  FIC_2409

);

localStorage.setItem(

  "TT_2409",

  TT_2409

);

localStorage.setItem(

  "PT_2409",

  PT_2409

);

localStorage.setItem(

  "FIC_24010",

  FIC_24010

);

localStorage.setItem(

  "TT_24010",

  TT_24010

);

localStorage.setItem(

  "PT_24010",

  PT_24010

);

localStorage.setItem(

  "FIC_24011",

  FIC_24011

);

localStorage.setItem(

  "TT_24011",

  TT_24011

);

localStorage.setItem(

  "PT_24011",

  PT_24011

);

localStorage.setItem(

  "FIC_24012",

  FIC_24012

);

localStorage.setItem(

  "TT_24012",

  TT_24012

);

localStorage.setItem(

  "PT_24012",

  PT_24012

);

localStorage.setItem(

  "KeroseneBottomComposition",

  JSON.stringify(

    KeroseneBottomComposition

  )

);

localStorage.setItem(

  "KeroseneGasComposition",

  JSON.stringify(

    KeroseneGasComposition

  )

);

localStorage.setItem(

  "KeroseneStrippingSeverity",

  StrippingSeverity

);



/* =========================================================
   P-105A / P-105B PUMPS
========================================================= */

const P105A_Running =
  pumpData?.["P-105A"]?.running ?? false;

const P105B_Running =
  pumpData?.["P-105B"]?.running ?? false;

const P105_Running =
  P105A_Running || P105B_Running;

/* =========================================================
   PUMP CAPACITY
========================================================= */

const P105_CAPACITY = 10.45;

/* =========================================================
   CONTROL VALVE
========================================================= */

const FCV2404_Opening =
  (valveData?.FCV_2404?.opening || 0) / 100;

/* =========================================================
   TARGET FLOW
========================================================= */

const targetFIC_24013 =
  P105_Running
    ? P105_CAPACITY * FCV2404_Opening
    : 0;

/* =========================================================
   FIC-24013
========================================================= */
  const FIC_24013 = flowOverrides?.FIC_24013 ? 0 : (processData.FIC_24013 || 0);

useEffect(() => {

  const lastUpdate =
    Number(
      localStorage.getItem(
        "FIC_24013_LastUpdate"
      )
    ) || Date.now();

  const elapsedSeconds =
    (Date.now() - lastUpdate) / 1000;

  if (elapsedSeconds <= 1) return;

  setProcessData(prev => {

    const current =
      Number(prev.FIC_24013 || 0);

    let next = current;

    const systemActive =
      P105A_Running ||
      P105B_Running;

    const target =
      systemActive
        ? targetFIC_24013
        : 0;

    /* ====================================
       MAXIMUM 100 SCANS
       ==================================== */

    const scans =
      Math.min(
        Math.floor(
          elapsedSeconds * 10
        ),
        100
      );

    for (
      let i = 0;
      i < scans;
      i++
    ) {

      next =
        next +
        (
          target -
          next
        ) * 0.12;

    }

    return {
      ...prev,
      FIC_24013: Number(
        next.toFixed(3)
      )
    };

  });

}, [
  targetFIC_24013,
  P105A_Running,
  P105B_Running
]);



useEffect(() => {

  localStorage.setItem(
    "FIC_24013_LastUpdate",
    String(Date.now())
  );

}, [FIC_24013]);




useEffect(() => {

  const timer = setInterval(() => {

    setProcessData(prev => {

      const current =
        Number(prev.FIC_24013 || 0);

      const target =
        Number(targetFIC_24013 || 0);

      const next =
        current +
        (target - current) * 0.12;

      return {
        ...prev,
        FIC_24013: Number(next.toFixed(3))
      };

    });

  }, 500);

  return () => clearInterval(timer);

}, [targetFIC_24013]);

/* =========================================================
   PT-24013
========================================================= */

let PT_24013 = 0.03;

if (
  P105_Running &&
  FCV2404_Opening > 0
) {

  PT_24013 = 1.2;

}

PT_24013 =
  Number(PT_24013.toFixed(3));

/* =========================================================
   TT-24013
========================================================= */

let TT_24013 =
  AtmosphericTemperature;

if (
  P105_Running &&
  FCV2404_Opening > 0
) {

  TT_24013 = TT_2409;

}

TT_24013 =
  Number(TT_24013.toFixed(2));






  localStorage.setItem(
  "FIC_24010",
  FIC_24010
);

localStorage.setItem(
  "TT_24010",
  TT_24010
);

localStorage.setItem(
  "PT_24010",
  PT_24010
);

localStorage.setItem(
  "FIC_2405",
  FIC_2405
);

localStorage.setItem(
  "TT_2405",
  TT_2405
);
localStorage.setItem(
  "TT_24020",
  TT_24020
);

localStorage.setItem(
  "PT_2405",
  PT_2405
);
localStorage.setItem(
  "FIC_2408",
  FIC_2408
);

localStorage.setItem(
  "TT_2408",
  TT_2408
);

localStorage.setItem(
  "PT_2406",
  PT_2406
);
localStorage.setItem(
  "FIC_24013",
  FIC_24013
);

localStorage.setItem(
  "TT_24013",
  TT_24013
);

localStorage.setItem(
  "PT_24013",
  PT_24013
);

localStorage.setItem(
  "StrippingSeverity",
  StrippingSeverity
);

localStorage.setItem(

  "DieselBottomComposition",

  JSON.stringify(

    DieselBottomComposition

  )

);




  // ✅ FIXED: Update PlantStore without causing re-renders
  useEffect(() => {
    const current = PlantStore.get().transmitters;
    
    if (
      current.TT_2408 === TT_2408 &&
      current.FIC_2408 === FIC_2408 &&
      current.PT_24013 === PT_24013 &&
      current.FIC_24013 === FIC_24013 &&
      current.FIC_2406 === FIC_2406 &&
      current.FIC_2407 === FIC_2407 &&
      current.PT_2406 === PT_2406
    ) {
      return;
    }

    PlantStore.set({
      transmitters: {
        ...current,
        TT_2408, FIC_2406, FIC_2407, FIC_2408, PT_2406, PT_24013, FIC_24013
      }
    });
  }, [TT_2408, FIC_2406, FIC_2407, FIC_2408, PT_2406, PT_24013, FIC_24013]);





  const ProductStripperReport = {

  /* ============================
      DIESEL STRIPPER
  ============================ */

  dieselFeedFlow: FIC_2401,
  dieselFeedTemperature: TT_2401,
  dieselFeedPressure: PT_2401,

  steamFlow: FIC_2403,
  steamTemperature: TT_2403,
  steamPressure: PT_2403,

  dieselBottomFlow: FIC_2404,
  dieselBottomTemperature: TT_2404,
  dieselBottomPressure: PT_2404,

  dieselOverheadFlow: FIC_2405,
  dieselOverheadTemperature: TT_2405,
  dieselOverheadPressure: PT_2405,

  dieselRecovery:

    DieselInlet > 0
      ? (DieselBottoms / DieselInlet) * 100
      : 0,

  dieselLoss:

    DieselGasReturn,

  strippingSeverity:

    StrippingSeverity,

  steamRatio:

    SteamRatio,

  steamStrippingFactor:

    SteamStrippingFactor,

  temperatureFactor:

    TemperatureFactor,

  pressureFactor:

    PressureFactor,



  /* ============================
      DIESEL PRODUCT QUALITY
  ============================ */

  dieselComposition:

    DieselBottomComposition,

  dieselGasComposition:

    {
      Diesel:
      DieselGasReturn
    },



  /* ============================
      KEROSENE STRIPPER
  ============================ */

  keroseneFeedFlow: FIC_2402,
  keroseneFeedTemperature: TT_2402,
  keroseneFeedPressure: PT_2402,

  reboilerInletFlow: FIC_24011,
  reboilerOutletFlow: FIC_24012,

  reboilerInletTemperature: TT_24011,
  reboilerOutletTemperature: TT_24012,

  keroseneBottomFlow: FIC_2409,
  keroseneBottomTemperature: TT_2409,
  keroseneBottomPressure: PT_2409,

  keroseneOverheadFlow: FIC_24010,
  keroseneOverheadTemperature: TT_24010,
  keroseneOverheadPressure: PT_24010,



  /* ============================
      REBOILER
  ============================ */

  reboilerDuty:

    ReboilerDuty,

  heatTransferred:

    HeatTransferred,

  heatTransferEfficiency:

    HeatTransferEfficiency,

  deltaT:

    DeltaT,



  /* ============================
      KEROSENE RECOVERY
  ============================ */

  keroseneRecovery:

    KeroseneInlet > 0

      ?

      (BottomKerosene /

      KeroseneInlet) * 100

      :

      0,

  keroseneLoss:

    KeroseneGasReturn,



  /* ============================
      PRODUCT COMPOSITION
  ============================ */

  keroseneComposition:

    KeroseneBottomComposition,

  keroseneGasComposition:

    KeroseneGasComposition,



  /* ============================
      PUMPS
  ============================ */

  dieselPumpFlow:

    FIC_2408,

  dieselPumpTemperature:

    TT_2408,

  dieselPumpPressure:

    PT_2406,



  kerosenePumpFlow:

    FIC_24013,

  kerosenePumpTemperature:

    TT_24013,

  kerosenePumpPressure:

    PT_24013,



  /* ============================
      OVERALL KPIs
  ============================ */

  overallRecovery:

    (

      (

        (

          DieselBottoms +

          BottomKerosene

        )

        /

        Math.max(

          DieselInlet +

          KeroseneInlet,

          1

        )

      )

      *100

    ),

  steamConsumption:

    FIC_2403,

  energyEfficiency:

    HeatTransferEfficiency * 100,

  overallPerformance:

    (
      (
        HeatTransferEfficiency * 0.35 +
        StrippingSeverity * 0.35 +
        (
          (
            DieselBottoms +
            BottomKerosene
          )
          /
          Math.max(
            DieselInlet +
            KeroseneInlet,
            1
          )
        ) * 0.30
      ) * 100
    )

};


localStorage.setItem(
    "ProductStripperReport",
    JSON.stringify(ProductStripperReport)
);





  return (
    <div className="ProductStripper-container">

      {/* TITLE */}
      <h2
        style={{
          position: "absolute",
          top: "0px",
          left: "260px",
          color: "white",
          background: "rgb(30, 5, 250)",
          padding: "2px 313px",
          zIndex: 10,
        }}
      >
        PRODUCT STRIPPERS
      </h2>


 {/* =================SHUTDOWN VALVES ================= */}

      
      {/* XV-2401 */}
      <Valve
        className="XV-2401"
        tag="XV_2401"
        x={712}
        y={425}
        isClosed={valves.XV_2401}
        toggle={toggleValve}
        r={90}
      />


      <button
          onClick={() => setShowLaboratory(true)}
          style={{
              position: "absolute",
              right: "350px",
              top: "90px",
              padding: "8px 16px",
              background: "#0b5ed7",
              color: "#fff",
              border: "none",
              borderRadius: "6px",
              cursor: "pointer",
              fontWeight: "bold",
              zIndex: 500
          }}
      >
          📑 Product Stripper Report
      </button>


      {
          showLaboratory && (
              <StripperLaboratory
                  onClose={() => setShowLaboratory(false)}
              />
          )
      }





      
        {/* ================= CONTROL VALVES SVG ================= */}
        

         {/* FCV-2401 */}
        <div
            style={{ position: "absolute", left: 1045, top: 311}}
            onMouseEnter={() => setHoveredValve("FCV_2401")}
            onMouseLeave={() => setHoveredValve(null)}
            onClick={() => openPanel("FCV_2401")}
          >

            {hoveredValve === "FCV_2401" && (
              <div style={tagStyle}>
                FCV_2401
              </div>
            )}

            <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-2401">
                    
          <defs>
            <linearGradient id="metal_2401">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>


          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_2401)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_2401)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>
      </div>
      
        {/* ================= CONTROL VALVES SVG ================= */}
        

         {/* FCV-2402 */}
        <div
            style={{ position: "absolute", left: 1112, top: 406, transform: "rotate(90deg)", transformOrigin: "center"}}
            onMouseEnter={() => setHoveredValve("FCV_2402")}
            onMouseLeave={() => setHoveredValve(null)}
            onClick={() => openPanel("FCV_2402")}
          >

            {hoveredValve === "FCV_2402" && (
              <div style={tagStyle}>
                FCV_2402
              </div>
            )}

            <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-2402">
                    
          <defs>
            <linearGradient id="metal_2402">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>


          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_2402)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_2402)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>
      </div>


      {/* ================= CONTROL VALVES SVG ================= */}
        

         {/* FCV-2403 */}
        <div
            style={{ position: "absolute", left: 315, top: 566}}
            onMouseEnter={() => setHoveredValve("FCV_2403")}
            onMouseLeave={() => setHoveredValve(null)}
            onClick={() => openPanel("FCV_2403")}
          >

            {hoveredValve === "FCV_2403" && (
              <div style={tagStyle}>
                FCV_2403
              </div>
            )}

            <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-2403">
                    
          <defs>
            <linearGradient id="metal_2403">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>


          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_2403)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_2403)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>
      </div>

      {/* ================= CONTROL VALVES SVG ================= */}
        

         {/* FCV-2404 */}
        <div
            style={{ position: "absolute", left: 1125, top: 617}}
            onMouseEnter={() => setHoveredValve("FCV_2404")}
            onMouseLeave={() => setHoveredValve(null)}
            onClick={() => openPanel("FCV_2404")}
          >

            {hoveredValve === "FCV_2404" && (
              <div style={tagStyle}>
                FCV_2404
              </div>
            )}

            <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-2404">
                    
          <defs>
            <linearGradient id="metal_2404">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>


          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_2404)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_2404)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>
      </div>


        
        {/* ================= CONTROL VALVE FACEPLATES ================= */}
          {openPanels.map((tag, index) => (
            <ControlValveControlPanel
              key={tag}
              tag={tag}
              data={valveData?.[tag] ?? DEFAULT_VALVES?.[tag]}
              update={updateValveData}
              close={() => closePanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 240 + index * 40
              }}
            />
          ))}

           {/* ================= PUMPS CONTROL VALVE FACEPLATES ================= */}
          {openPumpPanels.map((tag, index) => (
            <PumpFaceplate
              key={tag}
              tag={tag}
              close={() => closePumpPanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 240 + index * 40
              }}
            />
          ))}





      {/* ================= CONTROL VALVE OUTPUTS ================= */}


      <ValveOutput
        value={Number(valveData?.FCV_2401?.opening || 0)}
        x={1067}
        y={358}
      />


      <ValveOutput
        value={Number(valveData?.FCV_2402?.opening || 0)}
        x={1099}
        y={425}
      />

      <ValveOutput
        value={Number(valveData?.FCV_2403?.opening || 0)}
        x={336}
        y={612}
      />

      <ValveOutput
        value={Number(valveData?.FCV_2404?.opening || 0)}
        x={1146}
        y={662}
      />







      <Transmitter
        tag="PT_2401"
        value={[PT_2401]}
        x={302}
        y={395}
        unit="MPa"
        max={1}
        HH={0.8}
        H={0.5}
        L={0}
        LL={0}
        c="lime"
        description="PRESSURE OF DIESEL DRAW FROM FRACTIONATION TOWER (T-102) TO DIESEL STRIPPER (T-103)"
      />

      <Transmitter
        tag="FIC_2401"
        value={[FIC_2401]}
        x={222}
        y={395}
        unit="BPM"
        max={35}
        HH={34}
        H={30}
        L={0}
        LL={0}
        c="lime"
        description="FLOWRATE OF DIESEL DRAW FROM FRACTIONATION TOWER (T-102) TO DIESEL STRIPPER (T-103)"
      />

      <Transmitter
        tag="TT_2401"
        value={[TT_2401]}
        x={132}
        y={395}
        unit="°C"
        max={600}
        HH={580}
        H={555}
        L={0}
        LL={0}
        c="lime"
        description="TEMPERATURE OF DIESEL DRAW FROM FRACTIONATION TOWER (T-102) TO DIESEL STRIPPER (T-103)"
      />


      <Transmitter
        tag="PT_2402"
        value={[PT_2402]}
        x={302}
        y={150}
        unit="MPa"
        max={1}
        HH={0.8}
        H={0.5}
        L={0}
        LL={0}
        c="lime"
        description="PRESSURE OF KEROSENE DRAW FROM FRACTIONATION TOWER (T-102) TO KEROSENE STRIPPER (T-104)"
      />

      <Transmitter
        tag="FIC_2402"
        value={[FIC_2402]}
        x={422}
        y={150}
        unit="BPM"
        max={35}
        HH={34}
        H={30}
        L={0}
        LL={0}
        c="lime"
        description="FLOWRATE OF KEROSENE DRAW FROM FRACTIONATION TOWER (T-102) TO KEROSENE STRIPPER (T-104)"
      />

      <Transmitter
        tag="TT_2402"
        value={[TT_2402]}
        x={162}
        y={150}
        unit="°C"
        max={600}
        HH={580}
        H={555}
        L={0}
        LL={0}
        c="lime"
        description="TEMPERATURE OF KEROSENE DRAW FROM FRACTIONATION TOWER (T-102) TO KEROSENE STRIPPER (T-104)"
      />

      <Transmitter
        tag="PT_2403"
        value={[PT_2403]}
        x={142}
        y={560}
        unit="MPa"
        max={1}
        HH={0.8}
        H={0.5}
        L={0}
        LL={0}
        c="lime"
        description="PRESSURE OF SUPERHEATED STEAM FROM CONVECTION ZONE OF FURNACE TO DIESEL STRIPPER (T-103)"
      />

      <Transmitter
        tag="TT_2403"
        value={[TT_2403]}
        x={232}
        y={560}
        unit="°C"
        max={600}
        HH={580}
        H={555}
        L={0}
        LL={0}
        c="lime"
        description="TEMPERATURE OF SUPERHEATED STEAM FROM CONVECTION ZONE OF FURNACE TO DIESEL STRIPPER (T-103)"
      />

      <Transmitter
        tag="PT_2404"
        value={[PT_2404]}
        x={502}
        y={450}
        unit="MPa"
        max={1}
        HH={0.8}
        H={0.5}
        L={0}
        LL={0}
        c="lime"
        description="PRESSURE OF DIESEL STRIPPER (T-103)"
      />

      <Transmitter
        tag="TT_2404"
        value={[TT_2404]}
        x={502}
        y={490}
        unit="°C"
        max={600}
        HH={580}
        H={555}
        L={0}
        LL={0}
        c="lime"
        description="TEMPERATURE OF DIESEL STRIPPER (T-103)"
      />

      <Transmitter
        tag="PT_2405"
        value={[PT_2405]}
        x={342}
        y={280}
        unit="MPa"
        max={1}
        HH={0.8}
        H={0.5}
        L={0}
        LL={0}
        c="lime"
        description="PRESSURE OF DIESEL GAS RETURN FROM DIESEL STRIPPER (T-103) TO FRACTIONATION TOWER (T-102)"
      />

      <Transmitter
        tag="FIC_2405"
        value={[FIC_2405]}
        x={242}
        y={280}
        unit="BPM"
        max={35}
        HH={34}
        H={30}
        L={0}
        LL={0}
        c="lime"
        description="FLOWRATE OF DIESEL GAS RETURN FROM DIESEL STRIPPER (T-103) TO FRACTIONATION TOWER (T-102)"
      />

      <Transmitter
        tag="TT_2405"
        value={[TT_2405]}
        x={152}
        y={280}
        unit="°C"
        max={600}
        HH={580}
        H={555}
        L={0}
        LL={0}
        c="lime"
        description="TEMPERATURE OF DIESEL GAS RETURN FROM DIESEL STRIPPER (T-103) TO FRACTIONATION TOWER (T-102)"
      />

      <Transmitter
        tag="FIC_2406"
        value={[FIC_2406]}
        x={962}
        y={310}
        unit="BPM"
        max={35}
        HH={34}
        H={30}
        L={0}
        LL={0}
        c="lime"
        description="FLOWRATE OF DIESEL FLOW THROUGH KETTLE REBOILER TO E-110"
      />

      <Transmitter
        tag="FIC_2407"
        value={[FIC_2407]}
        x={1147}
        y={530}
        unit="BPM"
        max={35}
        HH={34}
        H={30}
        L={0}
        LL={0}
        c="lime"
        description="FLOWRATE OF DIESEL FLOW THROUGH KETTLE REBOILER BYPASS LINE TO E-110"
      />

      <Transmitter
        tag="FIC_2408"
        value={[FIC_2408]}
        x={1137}
        y={200}
        unit="BPM"
        max={35}
        HH={34}
        H={30}
        L={0}
        LL={0}
        c="lime"
        description="FLOWRATE OF DIESEL FLOW TO E-110"
      />

      <Transmitter
        tag="TT_2408"
        value={[TT_2408]}
        x={1082}
        y={115}
        unit="°C"
        max={600}
        HH={580}
        H={555}
        L={0}
        LL={0}
        c="lime"
        description="TEMPERATURE OF DIESEL FLOW TO E-110"
      />

      <Transmitter
        tag="TT_2406"
        value={[TT_2406]}
        x={642}
        y={720}
        unit="°C"
        max={600}
        HH={580}
        H={555}
        L={0}
        LL={0}
        c="lime"
        description="TEMPERATURE OF DIESEL FLOW THROUGH KETTLE REBOILER  TO E-110"
      />

      <Transmitter
        tag="PT_2406"
        value={[PT_2406]}
        x={542}
        y={810}
        unit="MPa"
        max={1}
        HH={0.8}
        H={0.5}
        L={0}
        LL={0}
        c="lime"
        description="PRESSURE OF DIESEL FLOW THROUGH KETTLE REBOILER  TO E-110"
      />

      <Transmitter
        tag="PT_24010"
        value={[PT_24010]}
        x={302}
        y={70}
        unit="MPa"
        max={1}
        HH={0.8}
        H={0.5}
        L={0}
        LL={0}
        c="lime"
        description="PRESSURE OF KEROSENE GAS RETURN FROM KEROSENE STRIPPER (T-104) TO FRACTIONATION TOWER (T-102)"
      />

      <Transmitter
        tag="FIC_24010"
        value={[FIC_24010]}
        x={422}
        y={70}
        unit="BPM"
        max={35}
        HH={34}
        H={30}
        L={0}
        LL={0}
        c="lime"
        description="FLOWRATE OF KEROSENE GAS RETURN FROM KEROSENE STRIPPER (T-104) TO FRACTIONATION TOWER (T-102)"
      />

      <Transmitter
        tag="TT_24010"
        value={[TT_24010]}
        x={162}
        y={70}
        unit="°C"
        max={600}
        HH={580}
        H={555}
        L={0}
        LL={0}
        c="lime"
        description="TEMPERATURE OF KEROSENE GAS RETURN FROM KEROSENE STRIPPER (T-104) TO FRACTIONATION TOWER (T-102)"
      />

      <Transmitter
        tag="TT_2409"
        value={[TT_2409]}
        x={682}
        y={160}
        unit="°C"
        max={600}
        HH={580}
        H={555}
        L={0}
        LL={0}
        c="lime"
        description="TEMPERATURE OF KEROSENE STRIPPER (T-104)"
      />

      <Transmitter
        tag="PT_2409"
        value={[PT_2409]}
        x={762}
        y={160}
        unit="MPa"
        max={1}
        HH={0.8}
        H={0.5}
        L={0}
        LL={0}
        c="lime"
        description="PRESSURE OF KEROSENE STRIPPER (T-104)"
      />


      <Transmitter
        tag="TT_24011"
        value={[TT_24011]}
        x={732}
        y={498}
        unit="°C"
        max={600}
        HH={580}
        H={555}
        L={0}
        LL={0}
        c="lime"
        description="TEMPERATURE OF KEROSENE DRAW FROM KEROSENE STRIPPER (T-104) TO KETTLE REBOILER (E-112)"
      />

      <Transmitter
        tag="FIC_24011"
        value={[FIC_24011]}
        x={822}
        y={498}
        unit="BPM"
        max={35}
        HH={34}
        H={30}
        L={0}
        LL={0}
        c="lime"
        description="FLOWRATE OF KEROSENE DRAW FROM KEROSENE STRIPPER (T-104) TO KETTLE REBOILER (E-112)"
      />

      <Transmitter
        tag="TT_24012"
        value={[TT_24012]}
        x={732}
        y={275}
        unit="°C"
        max={600}
        HH={580}
        H={555}
        L={0}
        LL={0}
        c="lime"
        description="TEMPERATURE OF KEROSENE DRAW FROM KETTLE REBOILER (E-112) BACK TO KEROSENE STRIPPER (T-104)"
      />

      <Transmitter
        tag="FIC_24012"
        value={[FIC_24012]}
        x={822}
        y={275}
        unit="BPM"
        max={35}
        HH={34}
        H={30}
        L={0}
        LL={0}
        c="lime"
        description="FLOWRATE OF KEROSENE DRAW FROM KETTLE REBOILER (E-112) BACK TO KEROSENE STRIPPER (T-104)"
      />


      <Transmitter
        tag="PT_24013"
        value={[PT_24013]}
        x={1062}
        y={840}
        unit="MPa"
        max={1}
        HH={0.8}
        H={0.5}
        L={0}
        LL={0}
        c="lime"
        description="PRESSURE OF KEROSENE FROM KEROSENE STRIPPER (T-104) THROUGH PUMPS (P-105A/B) TO E-106A/B"
      />


      <Transmitter
        tag="TT_24013"
        value={[TT_24013]}
        x={1119}
        y={728}
        unit="°C"
        max={600}
        HH={580}
        H={555}
        L={0}
        LL={0}
        c="lime"
        description="TEMPERATURE OF KEROSENE FROM KEROSENE STRIPPER (T-104) THROUGH PUMPS (P-105A/B) TO E-106A/B"
      />

      <Transmitter
        tag="FIC_24013"
        value={[FIC_24013]}
        x={1029}
        y={658}
        unit="BPM"
        max={35}
        HH={34}
        H={30}
        L={0}
        LL={0}
        c="lime"
        description="FLOWRATE OF KEROSENE FROM KEROSENE STRIPPER (T-104) THROUGH PUMPS (P-105A/B) TO E-106A/B"
      />







      
            <LevelTransmitterIndicator
              tag="LT_2401"
              totalLevel={500}
              inflows={[FIC_2404]}
              outflows={[FIC_2408]}
              inflowTags={["FIC_2404"]}
              outflowTags={["FIC_2408"]}
              responseFactor={0.05}
              columnX={419}
              columnY={540}
              columnWidth={72}
              columnHeight={84}
              textX={506}
              textY={550}
              showFlow={true}
              backgroundOpacity={0.00}
              liquidOpacity={0.7}
              service="diesel"
            />

            <LevelTransmitterIndicator
              tag="LT_2402"
              totalLevel={500}
              inflows={[FIC_2409]}
              outflows={[FIC_24013]}
              inflowTags={["FIC_2409"]}
              outflowTags={["FIC_24013"]}
              responseFactor={0.05}
              columnX={587}
              columnY={300}
              columnWidth={76}
              columnHeight={84}
              textX={500}
              textY={280}
              showFlow={true}
              backgroundOpacity={0.00}
              liquidOpacity={0.7}
              service="kerosene"
            />


            <Pump
              tag="P-106A"
              x={346}
              y={779}
              rpm={1800}
              bladeCount={pumpData?.["P-106A"]?.bladeCount || 3}
              size={pumpData?.["P-106A"]?.size || 45}
              onClick={openPumpPanel}
            />

            <Pump
              tag="P-106B"
              x={346}
              y={880}
              rpm={1800}
              bladeCount={pumpData?.["P-106B"]?.bladeCount || 3}
              size={pumpData?.["P-106B"]?.size || 45}
              onClick={openPumpPanel}
            />

            <Pump
              tag="P-105A"
              x={926}
              y={769}
              rpm={1800}
              bladeCount={pumpData?.["P-105A"]?.bladeCount || 3}
              size={pumpData?.["P-105A"]?.size || 45}
              onClick={openPumpPanel}
            />

            <Pump
              tag="P-105B"
              x={926}
              y={867}
              rpm={1800}
              bladeCount={pumpData?.["P-105B"]?.bladeCount || 3}
              size={pumpData?.["P-105B"]?.size || 45}
              onClick={openPumpPanel}
            />





    </div>
  );
}

export default ProductStripper;